export const env = {
  uid: "0", // 用户 uid, 用于日志上下文或登录校验
  /** Wiki/攻略数据版本号，传值则查询该版本数据，不传则后台返回正式版本数据 */
  wikiVersion: "",
};

/** 游戏工具 id，用于数据中台上报，各项目按自身 manifest.json 中的 toolId 填写 */
export const getToolId = () => {
  // 根据路由区分：攻略 (hash 包含 #/strategy) 使用 xr0oixch，wiki 使用 4tqf4kqv
  const hash = window.location.hash;
  if (hash.includes("#/strategy")) return "xr0oixch";
  return "4tqf4kqv";
};
export const TOOL_ID = getToolId();

/** 游戏工具类型，用于数据中台上报，见 GameToolInfo.toolType */
const getToolType = () => {
  const hash = window.location.hash;
  // 1-wiki, 2-攻略
  if (hash.includes("#/strategy")) return 2;
  return 1;
};
export const TOOL_TYPE = getToolType();
